import { render, staticRenderFns } from "./fruit-transfer.vue?vue&type=template&id=4d6787aa&scoped=true&"
import script from "./fruit-transfer.vue?vue&type=script&lang=js&"
export * from "./fruit-transfer.vue?vue&type=script&lang=js&"
import style0 from "./fruit-transfer.vue?vue&type=style&index=0&id=4d6787aa&prod&lang=scss&scoped=true&"
import style1 from "./fruit-transfer.vue?vue&type=style&index=1&id=4d6787aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6787aa",
  null
  
)

export default component.exports